<template>
  <nav
    class="navbar is-primary no-print"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <router-link class="navbar-item" to="/">
        <!-- <img src="@/assets/logo.png" width="30" height="30"> -->
        <span>&nbsp;&nbsp;{{ this.user.username }}</span>
      </router-link>
      <a
        role="button"
        class="navbar-burger"
        aria-label="menu"
        aria-expanded="false"
        :class="{ 'is-active': isMenuActive }"
        @click="isMenuActive = !isMenuActive"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div class="navbar-menu" :class="{ 'is-active': isMenuActive }">
      <div class="navbar-start">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ເມູນ 1</span>
          </a>

          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/company/equipmentOrderWaitApproveReport"
              active-class="is-active"
              exact
            >
              <span>ເມູນ 1.1</span>
            </router-link>


            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/company/equipmentPaymentWaitApproveReport"
              active-class="is-active"
              exact
            >
              <span>ເມູນ 1.2</span>
            </router-link>
            <hr class="menu-sperator" />
          </div>
        </div>

        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ເມູນ 2</span>
          </a>

          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/company/equipmentOrderWaitApproveReport"
              active-class="is-active"
              exact
            >
              <span>ເມູນ 2.1</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/company/equipmentPaymentWaitApproveReport"
              active-class="is-active"
              exact
            >
              <span>ເມູນ 2.2</span>
            </router-link>
            <hr class="menu-sperator" />
          </div>
        </div>
        
      </div>

      <div class="navbar-end">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ຜູ້ໃຊ້ງານ</span>
          </a>
          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/form/userProfile"
              :exact="true"
              active-class="is-active"
            >
              <span>ຂໍ້ມູນສ່ວນຕົວ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/login"
              :exact="true"
              active-class="is-active"
            >
              <span>ອອກຈາກລະບົບ</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { get } from "vuex-pathify";

export default {
  name: "ReportMenu",
  data() {
    return {
      isMenuActive: false
    };
  },
  computed: {
    user: get("loginData")
  },
  methods: {
    menuClicked() {
      this.isMenuActive = false;
    }
  }
};
</script>

<style scoped>
.navbar-item {
  white-space: nowrap;
}
.navbar-end {
  padding-right: 60px;
}
</style>
